import { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
    const [isDark, setIsDark] = useState(() => {
        try {
            if (typeof window !== 'undefined') {
                // Verificar si hay una preferencia guardada en localStorage
                const saved = localStorage.getItem('theme');
                if (saved) {
                    return saved === 'dark';
                }
                // Si no hay preferencia guardada, usar la preferencia del sistema
                if (typeof window.matchMedia === 'function') {
                    return window.matchMedia('(prefers-color-scheme: dark)').matches;
                }
            }
        } catch (e) {
            // ignore and fallthrough to default
        }
        return false;
    });

    useEffect(() => {
        // Aplicar el tema al documento
        if (isDark) {
            document.documentElement.classList.add('dark');
            localStorage.setItem('theme', 'dark');
        } else {
            document.documentElement.classList.remove('dark');
            localStorage.setItem('theme', 'light');
        }
    }, [isDark]);

    const toggleTheme = () => {
        setIsDark(prev => !prev);
    };

    return (
        <ThemeContext.Provider value={{ isDark, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
}

export function useTheme() {
    const context = useContext(ThemeContext);
    if (context === undefined) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
}
